import { push } from 'connected-react-router'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { decideLegalAndOperatingNames, replaceUrlParams } from '../../../app/utils'
import { fetchApplicationWithIdAndSetStore } from '../../../redux/slice/collectionApplicationSlice'
import { SuccessPanel } from '../../../components/MessagePanels/Panels'
import { Button } from '../../../components/RegularComponents'
import { agencyApplicationSelector } from '../../../redux/selector/agencyApplicationSelector'
import * as CONST from "../../../app/constants"
import { applicationTypeFromLicenceSubType } from '../../../redux/slice/applicationsUtils';

export const RenewalPaymentConfirmation = () => {

    const dispatch = useDispatch()
    const { agencyApplication } = useSelector(agencyApplicationSelector);

    const applicationType = applicationTypeFromLicenceSubType(agencyApplication.licencingSubType)
    const applicationMode = CONST.APPLICATION_MODE_RENEW

    const [legalName, setLegalName] = useState("")
    const [operatingName, setOperatingName] = useState("")

    let typeString = "Mortgage Lender"
    
    if(applicationType === CONST.APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
        typeString = "Mortgage Administrator"
    }

    const renderHeader = () => {
        const label1 = (operatingName ? operatingName : (legalName ?? "Payment Confirmation"))
        const label2 = operatingName ? legalName : null

        return (
            <div className="row topMarginMedium">
                <div className="col-lg-8" style={{fontSize: "2.2rem"}}>
                    {label1}
                </div>
                {label2 && 
                <div className="col-lg-8" style={{fontSize: "1.6rem"}}>
                    {label2}
                </div>}
            </div>)
    }

    useEffect(() => {
        if(!agencyApplication?.businessLicenceData) {
            dispatch(fetchApplicationWithIdAndSetStore(agencyApplication.id))
                .then(data => {
                    const { legalName, operatingName} = decideLegalAndOperatingNames(data?.businessLicenceData?.companyRjscDetails)
                    setLegalName(legalName)
                    setOperatingName(operatingName)
                })
        }
    }, [
        agencyApplication?.businessLicenceData,
        agencyApplication?.id,
        dispatch
    ])

    return (
        <div className="container">
            { renderHeader() }
            <div className="row topMarginMedium">
                <SuccessPanel>
                    <b>{`Your ${typeString} Licence renewal application was submitted.`}</b>
                </SuccessPanel>
            </div>
            <div className="row topMarginLarge bottomMarginLarge">
                <div className="col-lg-8 bottomMarginNormal">
                    Your application will be reviewed by Business Licensing.
                </div>
                <div className="col-lg-8">
                    If <b>more information</b> about your application is needed, <b>Business Licensing will contact you.</b>
                </div>
            </div>
            <div className="row topMarginLarge bottomMarginLarge">
                <div className="col-lg-2">
                    <Button
                        id="payment-confirmation-go-home-button"
                        buttonType="regular_primary"
                        text={`Go to ${typeString} Home Page`}
                        onClick={() => {
                            dispatch(push(replaceUrlParams(
                                CONST.ROUTE_PATH.WELCOME, 
                                applicationType, 
                                applicationMode
                            )))
                        }}
                    />
                </div>
            </div>
        </div>
    )
}